import { VAlert } from 'vuetify/lib/components/VAlert';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notify-wrapper"},[_c('transition-group',{attrs:{"name":"fade"}},_vm._l((_vm.notifications),function(item){return _c(VAlert,{key:item.key,attrs:{"type":item.type,"dismissible":"","transition":"fade"},on:{"input":function($event){return _vm.close(item)}}},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(item.title))]),_c('br'),_c('span',{domProps:{"innerHTML":_vm._s(item.text)}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }